/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface CreateClassRoomResponse
 */
export interface CreateClassRoomResponse {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof CreateClassRoomResponse
     */
    id: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {string}
     * @memberof CreateClassRoomResponse
     */
    name: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateClassRoomResponse
     */
    entityId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateClassRoomResponse
     */
    displayName?: string | null;
}

/**
 * Check if a given object implements the CreateClassRoomResponse interface.
 */
export function instanceOfCreateClassRoomResponse(value: object): value is CreateClassRoomResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function CreateClassRoomResponseFromJSON(json: any): CreateClassRoomResponse {
    return CreateClassRoomResponseFromJSONTyped(json, false);
}

export function CreateClassRoomResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateClassRoomResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': ApiUserTasksGetPageParameterFromJSON(json['id']),
        'name': json['name'],
        'entityId': json['entityId'] == null ? undefined : json['entityId'],
        'displayName': json['displayName'] == null ? undefined : json['displayName'],
    };
}

export function CreateClassRoomResponseToJSON(json: any): CreateClassRoomResponse {
    return CreateClassRoomResponseToJSONTyped(json, false);
}

export function CreateClassRoomResponseToJSONTyped(value?: CreateClassRoomResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': ApiUserTasksGetPageParameterToJSON(value['id']),
        'name': value['name'],
        'entityId': value['entityId'],
        'displayName': value['displayName'],
    };
}

